import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Sun, Moon, Leaf, TestTube, Books, MagnifyingGlass, Calendar, Scales, BracketsCurly, Database, ShoppingCart, CalendarBlank } from "@phosphor-icons/react";

export default function Header() {
  const [dark, setDark] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const saved = localStorage.getItem("theme") === "dark";
    setDark(saved);
    document.documentElement.classList.toggle("dark", saved);
  }, []);

  const toggle = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem("theme", next ? "dark" : "light");
  };

  const navItems = [
    { to: "/", label: "Calculator", icon: TestTube, testId: "nav-calculator" },
    { to: "/builder", label: "Builder", icon: BracketsCurly, testId: "nav-builder" },
    { to: "/planner", label: "Planner", icon: CalendarBlank, testId: "nav-planner" },
    { to: "/search", label: "Search", icon: MagnifyingGlass, testId: "nav-search" },
    { to: "/log", label: "Daily Log", icon: Calendar, testId: "nav-log" },
    { to: "/grocery", label: "Grocery", icon: ShoppingCart, testId: "nav-grocery" },
    { to: "/compare", label: "Compare", icon: Scales, testId: "nav-compare" },
    { to: "/library", label: "Library", icon: Books, testId: "nav-library" },
    { to: "/database", label: "Food DB", icon: Database, testId: "nav-database" },
  ];

  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background" data-testid="app-header">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="brand-link">
          <div className="h-8 w-8 border border-foreground/80 flex items-center justify-center bg-primary text-primary-foreground">
            <Leaf weight="fill" size={18} />
          </div>
          <div className="leading-tight">
            <div className="font-display font-black text-lg tracking-tight">NUTRIENT/LAB</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">v.01 · research engine</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1" data-testid="main-nav">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = location.pathname === item.to || (item.to === "/library" && location.pathname.startsWith("/recipe"));
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={item.testId}
                className={`px-3.5 h-9 flex items-center gap-2 text-sm rounded-full transition-colors duration-200 ${
                  active
                    ? "bg-[#C8FF3F] text-black border border-[#C8FF3F] font-semibold shadow-sm"
                    : "bg-neutral-100 text-neutral-800 border border-neutral-300 hover:bg-neutral-200 hover:border-neutral-400"
                }`}
              >
                <Icon size={16} weight={active ? "fill" : "regular"} />
                <span className="font-medium">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        <button
          onClick={toggle}
          data-testid="theme-toggle"
          className="h-9 w-9 rounded-full bg-neutral-100 text-neutral-800 border border-neutral-300 flex items-center justify-center hover:bg-neutral-200 transition-colors duration-200"
          aria-label="Toggle theme"
        >
          {dark ? <Sun size={16} weight="fill" /> : <Moon size={16} weight="fill" />}
        </button>
      </div>
    </header>
  );
}
